<script setup>
import { ref, computed, onMounted } from 'vue'
import { useAuthStore } from '../stores/auth'
import LoginModal from './LoginModal.vue'
import { useWebsiteConfigStore } from '../stores/website/configStore'
import { useGamesStore } from '../stores/games/gamesStore'
import GameJackpot from '../components/GameJackpot.vue';
import GameCategories from '../components/GameCategories.vue'
import GameProviders from '../components/GameProviders.vue'
import GameBanners from '../components/GameBanners.vue'
import GameGrid from '../components/GameGrid.vue'
import GameSearch from '../components/GameSearch.vue'
import GamePagination from '../components/GamePagination.vue'
import GameWebsite from '../components/GameWebsite.vue'
import LoadingView from '../components/LoadingView.vue'
import GamePlayer from '../components/GamePlayer.vue'
import CashbackNotification from '../components/CashbackNotification.vue'
import GameNotification from '../components/GameNotification.vue'
import JackpotNotification from '../components/JackpotNotification.vue'
import 'swiper/css'
import 'swiper/css/pagination'


const websiteStore = useWebsiteConfigStore()
const isMobileView = ref(false)
const showLoginModal = ref(false)
const isLoading = ref(true)
const authStore = useAuthStore()
const gamesStore = useGamesStore() 
const currentPage = ref(1)
const gamesPerPage = 18
const branding = computed(() => websiteStore.config.branding)
const timer = ref(null)


// Computed properties
const isAuthenticated = computed(() => authStore.isAuthenticated)
const activeGame = computed(() => gamesStore.activeGame)

onMounted(async () => {
  await websiteStore.loadConfig();
  const checkMobile = () => {
    isMobileView.value = window.innerWidth <= 768;
  };
  window.addEventListener('message', (event) => {
    console.log('Mensaje del iframe:', event.data);
  });
  checkMobile();
  window.addEventListener('resize', checkMobile);
  
  if (authStore.isAuthenticated) {
    isLoading.value = true;  // Mostrar loading
    try {
      await Promise.all([
        authStore.initializeAuth()
      ]);
    } finally {
      isLoading.value = false;  // Ocultar loading cuando todo esté cargado
    }
  } else {
    setTimeout(() => {
      showLoginModal.value = true;
      isLoading.value = false;
    }, 4000);
  }
})

const openLoginModal = () => {
 if (timer.value) {
   clearTimeout(timer.value)
 }
 showLoginModal.value = true
}

const handleLoginSuccess = async () => {
  isLoading.value = true; // Activar loading primero
  showLoginModal.value = false; // Cerrar modal inmediatamente después
  try {
    await authStore.initializeAuth();
  } finally {
    isLoading.value = false;
  }
};

const handleGameError = (error) => {
  console.warn('Game resource loading warning:', error);
};
</script>

<template>
  <LoadingView 
      v-if="isLoading"
      message="Loading game resources..."
    />

  <div v-else class="games-container">
    
    <!-- Game View When Its launch -->
    <div v-if="activeGame" class="game-wrapper">
     <div class="game-header">
      <img :src="branding?.logo_mobile" class="header-logo" alt="Logo" />
      <GameNotification />
       <!-- Poner la notificación aquí dentro del header -->
    <CashbackNotification />
    <JackpotNotification />
    <button @click="gamesStore.closeGame" class="exit-btn">
      <font-awesome-icon icon="xmark" />
    </button>
     
      </div> 
      <div class="game-content">
        <iframe 
          :src="activeGame.gameUrl" 
          class="game-frame"
          allow="fullscreen"
          @error="handleGameError"
          ref="gameFrame"
        ></iframe>
      </div>
    </div>
    <!-- Lobby View -->
    <template v-else>
      <!-- Header --> 
      <header v-if="isAuthenticated" class="jackpots-header">
        <img :src="branding?.logo_mobile" class="header-logo" />
        <GameJackpot/>
        <GamePlayer 
    :isMobileView="true"
   />
    </header>
    <GameProviders 
  v-if="!isMobileView" 
  class="providers-row-view" 
  displayMode="rows" 
  :providersPerRow="12" 
   @page-reset="currentPage = 1" 
/>


   <!-- Main Content -->
   <div class="main-content" @click="openLoginModal">
   <!-- Banners Section -->
   <GameBanners 
  v-if="isAuthenticated && isMobileView" 
  type="banners"
  class="main-banners"
/>
   <!-- Categories -->
   <GameCategories class="search-and-filter" v-if="isAuthenticated" />
   <!-- seacrh bar -->
   <div class="search-and-filter" v-if="isAuthenticated">
    <!-- News Banner -->
    <GameBanners 
  v-if="isAuthenticated" 
  type="news"
   />
    <!-- Search  search section Input -->
    <GameSearch />
   <!-- Provider Selector -->
   <GameProviders @page-reset="currentPage = 1" />
</div>
    <!-- Grid Games -->
  <main class="games-grid">
     <!--  User - When is not Authneticated -->
     <template v-if="!isAuthenticated">
  <GameWebsite 
    :branding="branding"
    :isLoading="isLoading"
  />
  </template>
     <template v-if="isAuthenticated">
          <!-- user get Games When is Authenticated -->
          <GameGrid
          :current-page="currentPage"
          :games-per-page="gamesPerPage"
          :isAuthenticated="isAuthenticated"
          @show-login="openLoginModal"
        />
      </template>
        </main>
        <!-- Pagination Controls -->
        <GamePagination
        v-if="isAuthenticated"
        v-model:currentPage="currentPage"
        :gamesPerPage="gamesPerPage"
      />
      </div>
      <!-- Footer fordesktop only-->
      <GamePlayer 
  :isMobileView="false"
/>

 </template>
    <!-- Modal  Login -->
    <LoginModal 
      v-if="showLoginModal && !isAuthenticated" 
      @close="showLoginModal = false" 
      @login-success="handleLoginSuccess" 
    />
  </div>
</template>
    
<style scoped>
@import '../assets/styles/main.css';

/* Regla base para todos los dispositivos */
.main-banners {
  display: none !important;
}

/* En dispositivos móviles: ocultar proveedores en filas, mostrar banners */
@media (max-width: 768px) {
  .providers-row-view {
    display: none !important;
  }
  
  .main-banners,
  .banners-section,
  [class*="banner"] {
    display: block !important;
  }
}

/* En desktop: asegurarse de que todos los banners estén ocultos */
@media (min-width: 769px) {
  .providers-row-view 
  .search-and-filter{
    display: block !important;
  }
  
  /* Selector más amplio para capturar todos los posibles banners */
  .main-banners,
  .banners-section,
  .swiper-container,
  /* // disable filter and bar  news banner */
  .search-and-filter,
  [class*="banner"],
  [id*="banner"],
  GameBanners,
  .GameBanners {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    width: 0 !important;
    height: 0 !important;
    overflow: hidden !important;
    position: absolute !important;
    pointer-events: none !important;
  }
}
</style>